import { faImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { StoppageDto } from "../../../DTOs/Stoppage/StoppageDto";
import { useGlobalModal } from "../../../components/Contexts/GlobalModalContext";
import StoppageImagesModal from "../StoppageImagesModal/StoppageImagesModal";
import { useOnlineStatus } from "../../../components/Hooks/useOnlineStatus";

type ViewStoppageImagesButtonProps = {
  stoppage: StoppageDto;
  onStoppageUpdated?: (updated: StoppageDto) => void;
};

const ViewStoppageImagesButton: React.FC<ViewStoppageImagesButtonProps> = ({
  stoppage,
  onStoppageUpdated
}) => {
  const { t } = useTranslation("stoppages");
  const { showModal } = useGlobalModal();
  const hasImages = !!stoppage.hasImages;
  const isOnline = useOnlineStatus();

  return (
    <Tooltip
      title={!isOnline ? t("images.offline") : hasImages ? t("images.view") : t("images.noneYet")}
      arrow
      placement="top"
    >
      <Button
        variant="outlined"
        component="label"
        classes={{
          root: `!min-w-0 relative flex-1 ${hasImages
            ? '!bg-theme-info/10 hover:!bg-theme-info/20'
            : '!bg-theme-surface-2 hover:!bg-theme-surface'
            }`
        }}
        size="small"
        disabled={!isOnline}
        sx={{ padding: 0.3 }}
        onClick={() => {
          showModal({
            content: (
              <StoppageImagesModal
                stoppage={stoppage}
                onStoppageUpdated={onStoppageUpdated}
              />
            ),
            tailwindMaxWidthClass: 'max-w-5xl'
          })
        }}
      >
        <FontAwesomeIcon
          icon={faImage}
          className={`text-xl ${hasImages ? 'text-theme-info' : 'text-theme-text'}`}
        />
        {hasImages && (
          <span className="absolute top-1 right-1 w-2.5 h-2.5 rounded-full bg-theme-success border border-theme-surface-2" />
        )}
      </Button>
    </Tooltip>
  )
};

export default ViewStoppageImagesButton;